class CustomProductGridSliderMain extends HTMLElement {
  connectedCallback() {
    const $main = $(this);
    const $slider = $main.find('.custom-product-grid-slider');

    if (!$slider.length) return;

    const $prevDesk = $main.find('.custom-slider-btn-prev-desk');
    const $nextDesk = $main.find('.custom-slider-btn-next-desk');
    const $prevMobile = $main.find('.custom-slider-btn-prev-mobile');
    const $nextMobile = $main.find('.custom-slider-btn-next-mobile');

    // Init slick
    $slider.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      dots: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 991, settings: { slidesToShow: 3 } },
        { breakpoint: 640, settings: { slidesToShow: 2, slidesToScroll: 1, centerMode: false } }
      ]
    });

    // Button actions
    $prevDesk.on('click', e => { e.preventDefault(); $slider.slick('slickPrev'); });
    $nextDesk.on('click', e => { e.preventDefault(); $slider.slick('slickNext'); });
    $prevMobile.on('click', e => { e.preventDefault(); $slider.slick('slickPrev'); });
    $nextMobile.on('click', e => { e.preventDefault(); $slider.slick('slickNext'); });

    // Arrow update
    const updateArrowState = () => {
      if (!$slider.hasClass('slick-initialized')) return;

      const slickObj = $slider.slick('getSlick');
      if (!slickObj) return;

      const slideCount = slickObj.slideCount || 0;
      const slidesToShow = slickObj.options.slidesToShow || 1;
      const current = $slider.slick('slickCurrentSlide');

      const isAtStart = current === 0;
      const isAtEnd = current >= slideCount - slidesToShow;

      $prevDesk.toggleClass('disabled', isAtStart);
      $prevMobile.toggleClass('disabled', isAtStart);
      $nextDesk.toggleClass('disabled', isAtEnd);
      $nextMobile.toggleClass('disabled', isAtEnd);
    };

    $slider.on('afterChange', updateArrowState);
    updateArrowState();
  }
}
customElements.define("custom-product-grid-slider-main", CustomProductGridSliderMain);

class CustomBlogGridSliderMain extends HTMLElement {
  connectedCallback() {
    const $main = $(this);
    const $slider = $main.find('.custom-blog-grid-slider');

    if (!$slider.length) return;

    const $prevDesk = $main.find('.custom-slider-btn-prev-desk');
    const $nextDesk = $main.find('.custom-slider-btn-next-desk');

    // Init slick
    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      prevArrow: $prevDesk,
      nextArrow: $nextDesk,
      dots: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 991, settings: { slidesToShow: 2 } },
        { breakpoint: 640, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: false } }
      ]
    });
  }
}
customElements.define("custom-blog-grid-slider-main", CustomBlogGridSliderMain);

class CustomSwatches extends HTMLElement {
  constructor() {
    super();
    this.onInputChange = this.onInputChange.bind(this);
  }

  connectedCallback() {
    // radios ONLY
    this.radios = this.querySelectorAll('input[type="radio"][data-variant-id]');
    this.radios.forEach(radio => {
      radio.addEventListener("change", this.onInputChange);
    });

    // const checked = this.querySelector('input[type="radio"][data-variant-id]:checked');
    // if (checked) {
    //   this.onInputChange({ target: checked });
    // }
    const anyRadio = this.radios[0];
    if (!anyRadio) return;

    const productId = anyRadio.getAttribute("data-product-id");
    const sectionId = anyRadio.getAttribute("data-section-id");

    const savedVariantId =
      sessionStorage.getItem(`selectedVariant-${sectionId}-${productId}`) ||
      sessionStorage.getItem(`selectedSwatch-${sectionId}-${productId}`);

    if (savedVariantId) {
      const savedRadio = this.querySelector(
        `input[type="radio"][data-variant-id="${savedVariantId}"]`
      );

      if (savedRadio) {
        savedRadio.checked = true;

        // Trigger the exact same logic as user clicking
        this.onInputChange({ target: savedRadio });
      }
    }
  }

  loadVariantData(productId, variantId) {
    const scriptTag = document.querySelector(`script[data-product-id='${productId}']`);

    if (!scriptTag) {
      console.warn(`Script tag for product ${productId} not found.`);
      return null;
    }

    const scriptContent = scriptTag.textContent;

    // Match: var variantDataMap = { ... };
    const match = scriptContent.match(/var\s+variantDataMap\s*=\s*(\{[\s\S]*?\});/);

    if (!match || !match[1]) {
      console.warn(`Could not parse variantDataMap for product ${productId}`);
      return null;
    }

    let variantMap;
    try {
      variantMap = JSON.parse(match[1]);
    } catch (err) {
      console.error(`JSON parse error for product ${productId}:`, err);
      return null;
    }

    return variantMap[variantId] || null;
  }

  getProductMediaArray(productId) {
    const script = document.querySelector(`script[data-product-id='${productId}']`);
    if (!script) return [];

    const scriptContent = script.textContent;

    const match = scriptContent.match(/var\s+productMedia\s*=\s*(\[[^\]]+\])/);
    if (!match) return [];

    try {
      const mediaArray = JSON.parse(match[1].replace(/(['"])?https?:/g, '')); // normalize protocol
      return mediaArray;
    } catch (e) {
      console.warn('Could not parse productMedia for product:', productId, e);
      return [];
    }
  }

  storeSelectedVariant(sectionId, productId, variantId) {
    sessionStorage.setItem('selectedVariant-' + sectionId + '-' + productId, variantId);
  }

  storeSelectedSwatch(sectionId, productId, variantId) {
    sessionStorage.setItem('selectedSwatch-' + sectionId + '-' + productId, variantId);
  }

  triggerDefaultVariant() {
    const firstChecked =
      this.querySelector('input[type="radio"][data-variant-id]:checked') ||
      this.querySelector('input[type="radio"][data-variant-id]');
    
    if (firstChecked) {
      this.onInputChange({ target: firstChecked });
    }
  }


  onInputChange(event) {
    const radio = event.target;

    const newVariantId = radio.getAttribute("data-variant-id");
    const newProductId = radio.getAttribute("data-product-id");
    const sectionId = radio.getAttribute("data-section-id");

    this.storeSelectedVariant(sectionId, newProductId, newVariantId);
    this.storeSelectedSwatch(sectionId, newProductId, newVariantId);

    const getVariantData = this.loadVariantData(newProductId, newVariantId);

    const productGrid = radio.closest("[card-product-grid]");

    const sliderElement = productGrid.querySelector('card-product-slider');

    if (sliderElement && $(sliderElement).hasClass('slick-initialized')) {

      const selectedColor = radio.value;
      $(sliderElement).slick('slickUnfilter');

      $(sliderElement).slick('slickFilter', function () {
        return $(this).attr('data-color') === selectedColor;
      });

      const slickObj = $(sliderElement).slick('getSlick');
      const visibleSlides = slickObj.$slides.filter(':visible').length;

      if (visibleSlides === 0) {
        $(sliderElement).slick('slickUnfilter');
      }

      // $(sliderElement).on('setPosition', updateSliderHeight);
      $(sliderElement).slick('setPosition');
    }


    // varinatId-replace-------------

    const productForm = productGrid.querySelector('product-form');
    if (productForm) {
      const idElement = productForm.querySelector("[name='id']")
      if (idElement) {
        idElement.value = newVariantId;
      }
    }

    // 🔁 Re-run active filter view after swatch change
    const filterView = document.querySelector("filter-view");

    if (filterView && typeof filterView.runActiveView === "function") {
      filterView.runActiveView();
    }

  }
}
customElements.define("custom-swatches", CustomSwatches);

class FilterView extends HTMLElement {
  constructor() {
    super();
  }

  runActiveView() {
    const activeBtn = this.querySelector("button.active");
    if (!activeBtn) return;

    this.handleFilterClick({
      isModelView: activeBtn.hasAttribute("model-view"),
      isDefaultView: activeBtn.hasAttribute("default-view")
    });
  }


  connectedCallback() {
    const buttons = this.querySelectorAll("button");

    // Add listeners to ALL buttons
    buttons.forEach(btn => {
      btn.addEventListener("click", () => {
        const isModelView = btn.hasAttribute("model-view");
        const isDefaultView = btn.hasAttribute("default-view");

        // Save selected view in sessionStorage
        if (isModelView) sessionStorage.setItem("selected_view", "model-view");
        if (isDefaultView) sessionStorage.setItem("selected_view", "default-view");

        // Update "active" class
        buttons.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");

        this.handleFilterClick({ isModelView, isDefaultView });
      });
    });

  }

  handleFilterClick({ isModelView, isDefaultView }) {
    const productCards = document.querySelectorAll("[card-product-grid]");

    productCards.forEach(card => {
      const productId = card.dataset.productId;
      if (!productId) return;

      const form = card.querySelector("form");
      if (!form) return;

      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return;

      const variantId = variantInput.value;

      const variantData = this.getVariantData(productId);
      if (!variantData || !variantData[variantId]) return;

      const variant = variantData[variantId];

      const checked_input = card.querySelector("input:checked");
      if(!checked_input) return;

      // MODEL VIEW
      if (isModelView && variant.model_image_url) {
        const images = card.querySelectorAll(`card-product-slider img[data-color="${checked_input.value}"][data-variant-index="true"]`);
        if (!images.length) return;
        images.forEach(img => {
          img.dataset.originalSrc = img.src;
          img.src = variant.model_image_url;
        });
      }

      // DEFAULT VIEW
      if (isDefaultView) {
        const images = card.querySelectorAll(`card-product-slider img[data-color="${checked_input.value}"][data-variant-index="true"]`);
        if (!images.length) return;
        images.forEach(img => {
          if (img.dataset.originalSrc) {
            console.log("img.dataset.originalSrc----true", img.dataset.originalSrc)
            img.src = img.dataset.originalSrc;
          }
        });
      }
    });
  }

  getVariantData(productId) {
    const scriptTag = document.querySelector(
      `script[data-product-id="${productId}"]`
    );
    if (!scriptTag) return null;

    const scriptContent = scriptTag.textContent;
    const match = scriptContent.match(
      /var\s+variantDataMap\s*=\s*(\{[\s\S]*?\});/
    );
    if (!match) return null;

    let jsonString = match[1];

    try {
      jsonString = jsonString
        .replace(/(\w+):/g, '"$1":')
        .replace(/,(\s*[}\]])/g, "$1");

      return JSON.parse(jsonString);
    } catch (err) {
      console.error("Variant map parse error:", productId, err);
      return null;
    }
  }
}
customElements.define("filter-view", FilterView);


class CardProductSlider extends HTMLElement {
  connectedCallback() {
    this.initSlider(); // auto initializes when inserted
  }

  // initSlider() {
  //   const $slider = $(this);

  //   if ($slider.hasClass("slick-initialized")) {
  //     $slider.slick("unslick");
  //   }

  //   $slider.slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     dots: true,
  //     arrows: true,
  //     infinite: true,
  //     adaptiveHeight: true
  //   });

  //   // $slider.on("setPosition", updateSliderHeight);

  //   const swatchComponent =
  //     this.closest("[card-product-grid]")?.querySelector("custom-swatches");

  //   if (swatchComponent?.triggerDefaultVariant) {
  //     swatchComponent.triggerDefaultVariant();
  //   }

  //   this.attachNestedSliderSwipeFix();
  // }

  initSlider() {
    const $slider = $(this);

    if ($slider.hasClass("slick-initialized")) {
      $slider.slick("unslick");
    }

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: false,
      adaptiveHeight: false
    });

    
    function updateDotsWindow(currentSlide) {
      const $dotsContainer = $slider.find(".slick-dots");
      const totalSlides = $slider.slick("getSlick").slideCount;
      const start = Math.floor(currentSlide / 3) * 3;
      const end = Math.min(start + 3, totalSlides);

      $dotsContainer.find("li").each(function (index) {
        if (index >= start && index < end) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }

    // Initial update
    $slider.on("init", function (event, slick) {
      updateDotsWindow(0); // initial update
    });

    // Update after each slide change
    $slider.on("afterChange", function (event, slick, currentSlide) {
      updateDotsWindow(currentSlide);
    });

    $slider.on("setPosition", function () {
      const currentSlide = $slider.slick("slickCurrentSlide");
      updateDotsWindow(currentSlide);
    });

    const swatchComponent =
      this.closest("[card-product-grid]")?.querySelector("custom-swatches");

    if (swatchComponent?.triggerDefaultVariant) {
      swatchComponent.triggerDefaultVariant();

      const currentSlide = $slider.slick("slickCurrentSlide");
      updateDotsWindow(currentSlide);
    }

    this.attachNestedSliderSwipeFix();
  }

  attachNestedSliderSwipeFix() {
    ["mousedown", "touchstart"].forEach(evt => {
      this.addEventListener(evt, () => {
        document.querySelectorAll(".custom-product-grid-slider").forEach(outer => {
          if (outer.slick) outer.slick.slickSetOption("swipe", false, false);
        });
      });
    });

    ["mouseup", "touchend"].forEach(evt => {
      this.addEventListener(evt, () => {
        document.querySelectorAll(".custom-product-grid-slider").forEach(outer => {
          if (outer.slick) outer.slick.slickSetOption("swipe", true, false);
        });
      });
    });
  }
}
customElements.define("card-product-slider", CardProductSlider);

class PriceRangeCustom extends HTMLElement {
  constructor() {
    super();
    // DOM references
    this.minThumb = this.querySelector('#min-thumb');
    this.maxThumb = this.querySelector('#max-thumb');
    this.minValue = this.querySelector('#min-value');
    this.maxValue = this.querySelector('#max-value');
    this.sliderRange = this.querySelector('.slider-range');
    this.sliderContainer = this.querySelector('.slider-container');

    this.minInput = this.querySelector('#price-min-input');
    this.maxInput = this.querySelector('#price-max-input');

    // Dataset values
    this.minPrice = parseInt(this.dataset.minPrice);
    this.maxPrice = parseInt(this.dataset.maxPrice);
    this.currencySymbol = this.dataset.currencySymbol;

    // State
    this.currentMinVal = this.minPrice;
    this.currentMaxVal = this.maxPrice;
    this.activeThumb = null;
    this.isDragging = false;
  }

  connectedCallback() {
    this.initializeSliderFromURL();

    // Mouse support
    this.minThumb.addEventListener('mousedown', this.handleMouseDown.bind(this));
    this.maxThumb.addEventListener('mousedown', this.handleMouseDown.bind(this));

    // Sync from mobile
    window.addEventListener('price-range-updated', (e) => {
      if (e.detail.source !== 'desktop') {
        this.setValues(e.detail.min, e.detail.max, false);
      }
    });
  }

  initializeSliderFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const minParam = urlParams.get('filter.v.price.gte');
    const maxParam = urlParams.get('filter.v.price.lte');
    if (minParam !== null) this.currentMinVal = parseInt(minParam);
    if (maxParam !== null) this.currentMaxVal = parseInt(maxParam);
    this.setValues(this.currentMinVal, this.currentMaxVal, false);
  }

  setValues(minVal, maxVal, dispatch = true) {
    const minPercent = ((minVal - this.minPrice) / (this.maxPrice - this.minPrice)) * 100;
    const maxPercent = ((maxVal - this.minPrice) / (this.maxPrice - this.minPrice)) * 100;

    this.minThumb.style.left = `${minPercent}%`;
    this.maxThumb.style.left = `${maxPercent}%`;
    this.sliderRange.style.left = `${minPercent}%`;
    this.sliderRange.style.width = `${maxPercent - minPercent}%`;

    this.currentMinVal = minVal;
    this.currentMaxVal = maxVal;

    this.minValue.textContent = `${this.currencySymbol}${minVal}`;
    this.maxValue.textContent = `${this.currencySymbol}${maxVal}`;

    this.minValue.style.left = `${minPercent}%`;
    this.maxValue.style.left = `${maxPercent}%`;

    if (this.minInput) this.minInput.value = minVal;
    if (this.maxInput) this.maxInput.value = maxVal;

    if (dispatch) {
      window.dispatchEvent(new CustomEvent('price-range-updated', {
        detail: { min: minVal, max: maxVal, source: 'desktop' }
      }));
    }
  }

  updateURL() {
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (form) {
      const searchParams = new URLSearchParams(new FormData(form.querySelector('form')));
      FacetFiltersForm.renderPage(searchParams.toString());
    }
  }

  handleMouseDown(e) {
    this.activeThumb = e.target;
    this.isDragging = true;
    document.addEventListener('mousemove', this.handleMouseMoveBound = this.handleMouseMove.bind(this));
    document.addEventListener('mouseup', this.handleMouseUpBound = this.handleMouseUp.bind(this));
  }

  handleMouseMove(e) {
    if (!this.isDragging || !this.activeThumb) return;
    const rect = this.sliderContainer.getBoundingClientRect();
    const percent = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));

    if (this.activeThumb === this.minThumb) {
      const maxPercent = parseFloat(this.maxThumb.style.left);
      this.minThumb.style.left = `${Math.min(percent, maxPercent)}%`;
    } else {
      const minPercent = parseFloat(this.minThumb.style.left);
      this.maxThumb.style.left = `${Math.max(percent, minPercent)}%`;
    }
    this.updateSlider();
  }

  updateSlider() {
    const minPercent = parseFloat(this.minThumb.style.left);
    const maxPercent = parseFloat(this.maxThumb.style.left);
    const minVal = Math.round(this.minPrice + (this.maxPrice - this.minPrice) * minPercent / 100);
    const maxVal = Math.round(this.minPrice + (this.maxPrice - this.minPrice) * maxPercent / 100);
    this.setValues(minVal, maxVal, true);
  }

  handleMouseUp() {
    if (this.isDragging) {
      this.isDragging = false;
      this.activeThumb = null;
      document.removeEventListener('mousemove', this.handleMouseMoveBound);
      document.removeEventListener('mouseup', this.handleMouseUpBound);
      this.updateURL();
    }
  }
}
customElements.define('price-range-custom', PriceRangeCustom);

class PriceRangeCustomMobile extends HTMLElement {
  constructor() {
    super();
    // DOM references
    this.minThumb = this.querySelector('#min-thumb_2');
    this.maxThumb = this.querySelector('#max-thumb_2');
    this.minValue = this.querySelector('#min-value_2');
    this.maxValue = this.querySelector('#max-value_2');
    this.sliderRange = this.querySelector('.slider-range_2');
    this.sliderContainer = this.querySelector('.slider-container_2');

    this.minInput = this.querySelector('#price-min-input');
    this.maxInput = this.querySelector('#price-max-input');

    // Dataset values
    this.minPrice = parseInt(this.dataset.minPrice);
    this.maxPrice = parseInt(this.dataset.maxPrice);
    this.currencySymbol = this.dataset.currencySymbol;

    // State
    this.currentMinVal = this.minPrice;
    this.currentMaxVal = this.maxPrice;
    this.activeThumb = null;
    this.isDragging = false;
  }

  connectedCallback() {
    this.initializeSliderFromURL();

    // Mouse support
    this.minThumb.addEventListener('mousedown', this.handleMouseDown.bind(this));
    this.maxThumb.addEventListener('mousedown', this.handleMouseDown.bind(this));

    // Touch support
    this.minThumb.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
    this.maxThumb.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });

    // Sync from desktop
    window.addEventListener('price-range-updated', (e) => {
      if (e.detail.source !== 'mobile') {
        this.setValues(e.detail.min, e.detail.max, false);
      }
    });
  }

  initializeSliderFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const minParam = urlParams.get('filter.v.price.gte');
    const maxParam = urlParams.get('filter.v.price.lte');
    if (minParam !== null) this.currentMinVal = parseInt(minParam);
    if (maxParam !== null) this.currentMaxVal = parseInt(maxParam);
    this.setValues(this.currentMinVal, this.currentMaxVal, false);
  }

  setValues(minVal, maxVal, dispatch = true) {
    const minPercent = ((minVal - this.minPrice) / (this.maxPrice - this.minPrice)) * 100;
    const maxPercent = ((maxVal - this.minPrice) / (this.maxPrice - this.minPrice)) * 100;

    this.minThumb.style.left = `${minPercent}%`;
    this.maxThumb.style.left = `${maxPercent}%`;
    this.sliderRange.style.left = `${minPercent}%`;
    this.sliderRange.style.width = `${maxPercent - minPercent}%`;

    this.currentMinVal = minVal;
    this.currentMaxVal = maxVal;

    // this.minValue.textContent = `${this.currencySymbol}${minVal}`;
    // this.maxValue.textContent = `${this.currencySymbol}${maxVal}`;

    this.minValue.style.left = `${minPercent}%`;
    this.maxValue.style.left = `${maxPercent}%`;

    if (this.minInput) this.minInput.value = minVal;
    if (this.maxInput) this.maxInput.value = maxVal;

    if (dispatch) {
      window.dispatchEvent(new CustomEvent('price-range-updated', {
        detail: { min: minVal, max: maxVal, source: 'mobile' }
      }));
    }
  }

  updateURL() {
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (form) {
      const searchParams = new URLSearchParams(new FormData(form.querySelector('form')));
      FacetFiltersForm.renderPage(searchParams.toString());
    }
  }

  // Mouse handlers
  handleMouseDown(e) {
    this.activeThumb = e.target;
    this.isDragging = true;
    document.addEventListener('mousemove', this.handleMouseMoveBound = this.handleMouseMove.bind(this));
    document.addEventListener('mouseup', this.handleMouseUpBound = this.handleMouseUp.bind(this));
  }

  handleMouseMove(e) {
    if (!this.isDragging || !this.activeThumb) return;
    const rect = this.sliderContainer.getBoundingClientRect();
    const percent = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));

    if (this.activeThumb === this.minThumb) {
      const maxPercent = parseFloat(this.maxThumb.style.left);
      this.minThumb.style.left = `${Math.min(percent, maxPercent)}%`;
    } else {
      const minPercent = parseFloat(this.minThumb.style.left);
      this.maxThumb.style.left = `${Math.max(percent, minPercent)}%`;
    }
    this.updateSlider();
  }

  handleMouseUp() {
    if (this.isDragging) {
      this.isDragging = false;
      this.activeThumb = null;
      document.removeEventListener('mousemove', this.handleMouseMoveBound);
      document.removeEventListener('mouseup', this.handleMouseUpBound);
      this.updateURL();
    }
  }

  // Touch handlers
  handleTouchStart(e) {
    this.activeThumb = e.target;
    this.isDragging = true;
    document.addEventListener('touchmove', this.handleTouchMoveBound = this.handleTouchMove.bind(this), { passive: false });
    document.addEventListener('touchend', this.handleTouchEndBound = this.handleTouchEnd.bind(this));
    e.preventDefault();
  }

  handleTouchMove(e) {
    if (!this.isDragging || !this.activeThumb) return;
    e.preventDefault();
    const touch = e.touches[0];
    const rect = this.sliderContainer.getBoundingClientRect();
    const percent = Math.max(0, Math.min(100, ((touch.clientX - rect.left) / rect.width) * 100));

    if (this.activeThumb === this.minThumb) {
      const maxPercent = parseFloat(this.maxThumb.style.left);
      this.minThumb.style.left = `${Math.min(percent, maxPercent)}%`;
    } else {
      const minPercent = parseFloat(this.minThumb.style.left);
      this.maxThumb.style.left = `${Math.max(percent, minPercent)}%`;
    }

    this.updateSlider();
  }

  handleTouchEnd() {
    if (this.isDragging) {
      this.isDragging = false;
      this.activeThumb = null;
      document.removeEventListener('touchmove', this.handleTouchMoveBound);
      document.removeEventListener('touchend', this.handleTouchEndBound);
      this.updateURL();
    }
  }

  updateSlider() {
    const minPercent = parseFloat(this.minThumb.style.left);
    const maxPercent = parseFloat(this.maxThumb.style.left);
    const minVal = Math.round(this.minPrice + (this.maxPrice - this.minPrice) * minPercent / 100);
    const maxVal = Math.round(this.minPrice + (this.maxPrice - this.minPrice) * maxPercent / 100);
    this.setValues(minVal, maxVal, true);
  }
}
customElements.define('price-range-custom-mobile', PriceRangeCustomMobile);

class ProductGallerySlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSliders();
    this.initCustomerTrigger();
    setTimeout(() => {
      this.checkYotpoRating();
    }, 1500);
  }

  initCustomerTrigger() {
    const triggerBtn = this.querySelector("#image__customer_click");

    const targetSection = document.querySelector("#product-customer-view");

    if (!triggerBtn) return;

    if (targetSection) {
      triggerBtn.addEventListener("click", () => {
        targetSection.scrollIntoView({ behavior: "smooth" });
      });
    } else {
      triggerBtn.style.display = "none";
    }
  }

  checkYotpoRating() {
    const yotpoWidgets = this.querySelectorAll('.yotpo-widget-instance');
    const reviewBtn = this.querySelector('button');

    if (!yotpoWidgets.length || !reviewBtn) return;

    yotpoWidgets.forEach((yotpoWidget) => {
      // Find inner element with aria-label
      const ratingEl = yotpoWidget.querySelector('[aria-label]');
      if (!ratingEl) return;

      const ariaLabel = ratingEl.getAttribute('aria-label'); 
      // e.g., "3.7 out 5 stars rating in total 3 reviews. Jump to reviews."
      const match = ariaLabel.match(/([\d.]+)\s*out\s*5/i);

      if (match) {
        const rating = parseFloat(match[1]);
        if (rating >= 4) {
          yotpoWidget.classList.remove('hidden'); // show widget
        }
      }
    });
  }


  initSliders() {
    const mainSlider = $(this).find("[main-slider-element]");
    const thumbSlider = $(this).find("[thumbnail-slider-element]");

    if (!mainSlider.length || !thumbSlider.length) {
      console.warn("Sliders not found inside product-gallery-slide");
      return;
    }

    // Thumbnail Slider (Vertical)
    thumbSlider.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: mainSlider,
      focusOnSelect: true,
      vertical: true,
      arrows: true,
      infinite: false,
      centerPadding: '10px'
    });

    // Main Slider (Single Image)
    mainSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: thumbSlider,
      arrows: true,
      infinite: false,
      fade: true,
    });

    mainSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        // Pause ALL videos first
        $(slick.$slides).find('video').each(function () {
          this.pause();
        });
      });

    mainSlider.on('afterChange', function(event, slick, currentSlide) {
      // Play video ONLY in active slide (if exists)
      const currentSlideEl = $(slick.$slides[currentSlide]).find('video').get(0);
      if (currentSlideEl) {
        currentSlideEl.play();
      }
    });
  }
}
customElements.define("product-gallery-slider", ProductGallerySlider);

class AccordionWrapper extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll('.accordion-item');
  }

  connectedCallback() {
    this.items.forEach(item => {
      const question = item.querySelector('.accordion-question');

      question.addEventListener('click', () => {
        this.toggleItem(item);
      });
    });
  }

  toggleItem(activeItem) {
    this.items.forEach(item => {
      const answer = item.querySelector('.accordion-answer');

      if (item === activeItem) {
        if (item.classList.contains('active')) {
          // Close
          answer.style.maxHeight = null;
          item.classList.remove('active');
        } else {
          // Open
          answer.style.maxHeight = answer.scrollHeight + 'px';
          item.classList.add('active');
        }
      } else {
        // Close others
        item.classList.remove('active');
        answer.style.maxHeight = null;
      }
    });
  }
}
customElements.define('accordion-wrapper', AccordionWrapper);

class ShippingDetails extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    this.cutoff = this.dataset.cutOff || '13:00'; // 1 PM EST

    this.hoursText = this.dataset.hours || 'hours';
    this.minutesText = this.dataset.minutes || 'minutes';
    this.secondsText = this.dataset.seconds || 'seconds';

    this.timeEl = this.querySelector('#shipping__time');
    if (!this.timeEl) return;

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    this.stop();
    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  stop() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  // ✅ Accurate EST/EDT time
  getESTNow() {
    const now = new Date();
    const estTime = new Date(
      now.toLocaleString('en-US', { timeZone: 'America/Toronto' })
    );
    return estTime;
  }

  formatCountdown(hours, minutes, seconds) {
    if (hours > 0) {
      return `${hours} ${this.hoursText} ${minutes} ${this.minutesText}`;
    }

    if (minutes > 0) {
      return `${minutes} ${this.minutesText} ${seconds} ${this.secondsText}`;
    }

    return `${seconds} ${this.secondsText}`;
  }

  update() {
    const [cutoffHour, cutoffMinute] = this.cutoff.split(':').map(Number);
    const now = this.getESTNow();

    // Cutoff is ALWAYS today at 1 PM EST
    const cutoffToday = new Date(now);
    cutoffToday.setHours(cutoffHour, cutoffMinute, 0, 0);

    // ❌ After 1 PM EST → hide widget permanently
    if (now >= cutoffToday) {
      this.style.display = 'none';
      this.stop(); // 🔥 stop timer
      return;
    }

    // ✅ Before 1 PM EST → show countdown
    const diffMs = cutoffToday - now;
    const totalSeconds = Math.floor(diffMs / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.timeEl.textContent = this.formatCountdown(hours, minutes, seconds);
    this.style.display = '';
  }
}

if (!customElements.get('shipping-details')) {
  customElements.define('shipping-details', ShippingDetails);
}


window.initProductSlider = () => {
  document.querySelectorAll("card-product-slider").forEach(el => el.initSlider?.());
};

function updateSliderHeight() {
  $('.custom-product-grid-slider.slick-initialized').each(function () {
    const $slides = $(this).find('> .slick-list > .slick-track > .slick-slide:not(.slick-cloned)');
    let maxHeight = Math.max(...$slides.toArray().map(s => $(s).css('height','auto').outerHeight(true)));
    $slides.css('height', maxHeight ? maxHeight + 'px' : '');
  });
}

window.addEventListener('load', () => { updateSliderHeight(); setTimeout(updateSliderHeight, 2000); });

function dropdownProducts() {
  const wrapper = document.querySelector('.dropdown-wrapper');
  if (!wrapper) return console.warn('Dropdown wrapper not found');
  const button = wrapper.querySelector('.dropdown-button'), menu = wrapper.querySelector('#dropdownMenu');
  button.addEventListener('click', () => wrapper.classList.toggle('show'));
  document.addEventListener('click', e => { if (!wrapper.contains(e.target)) wrapper.classList.remove('show'); });
  menu.querySelectorAll('.dropdown-item').forEach(item => item.addEventListener('click', () => wrapper.classList.remove('show')));
}
dropdownProducts();

document.addEventListener("DOMContentLoaded", () => {
  // Product description toggle
  const desc = document.querySelector(".product-description"), btn = document.querySelector(".read-more-btn");
  btn?.addEventListener("click", () => {
    desc.style.maxHeight = desc.classList.toggle("expanded") ? desc.scrollHeight + "px" : "38px";
  });

  // FAQ accordion
  document.querySelectorAll('.faq-item').forEach(item => {
    const q = item.querySelector('.faq-question'), a = item.querySelector('.faq-answer');
    q.addEventListener('click', () => {
      const open = a.style.maxHeight;
      document.querySelectorAll('.faq-answer').forEach(ans => { ans.style.maxHeight = null; ans.closest('.faq-item').classList.remove('active'); });
      if (!open) { a.style.maxHeight = a.scrollHeight + 'px'; item.classList.add('active'); }
    });
  });

  // Footer accordion
  const headings = document.querySelectorAll(".footer-block--menu .footer-block__heading");
  const setupAccordion = () => {
    headings.forEach(h => {
      const c = h.nextElementSibling;
      if (window.innerWidth <= 768) c.style.maxHeight = c.classList.contains("open") ? c.scrollHeight + "px" : "0px";
      else c.style.maxHeight = "none";
    });
  };
  headings.forEach(h => h.addEventListener("click", () => {
    if (window.innerWidth > 768) return;
    const c = h.nextElementSibling;
    h.classList.toggle("active");
    c.classList.toggle("open");
    c.style.maxHeight = c.classList.contains("open") ? c.scrollHeight + "px" : "0px";
  }));
  setupAccordion();
  window.addEventListener("resize", setupAccordion);

  // Video wrapper
  document.querySelectorAll(".custom-video-wrapper").forEach(wrapper => {
    const video = wrapper.querySelector("video.custom-video"), playBtn = wrapper.querySelector(".play-btn");
    if (!video) return;
    if (!playBtn) { video.play(); video.muted = true; wrapper.classList.add("active"); return; }

    playBtn.addEventListener("click", () => { video.muted = false; video.play(); wrapper.classList.add("active"); playBtn.style.display = "none"; });
    video.addEventListener("click", () => { video.paused ? video.play() : (video.pause(), video.muted = true, wrapper.classList.remove("active"), playBtn.style.display = "block"); });
    video.addEventListener("play", () => { wrapper.classList.add("active"); playBtn.style.display = "none"; });
    video.addEventListener("pause", () => { wrapper.classList.remove("active"); playBtn.style.display = "block"; });
  });

  // Load more
  const loadMoreBtn = document.querySelector('.js-load-more');
  loadMoreBtn?.addEventListener('click', async () => {
    const totalPagesEl = document.querySelector('[data-total-pages]'), currentPageEl = document.querySelector('[data-current-page]'),
          nextUrlEl = document.querySelector('[data-next-url]'), grid = document.querySelector('.grid--view-items');
    if (!totalPagesEl || !currentPageEl || !nextUrlEl || !grid) return;
    let totalPages = +totalPagesEl.value, currentPage = +currentPageEl.value;
    if (currentPage >= totalPages) return loadMoreBtn.style.display = 'none';
    loadMoreBtn.disabled = true; loadMoreBtn.querySelector('[load-more-text]')?.classList.add('hide'); loadMoreBtn.querySelector('[loader]')?.classList.remove('hide');
    const nextPage = currentPage + 1, nextUrl = nextUrlEl.value.replace(/page=\d+/, 'page=' + nextPage);
    try {
      const res = await fetch(nextUrl), html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html'), newItems = doc.querySelector('.grid--view-items');
      if (newItems?.innerHTML.trim()) { grid.insertAdjacentHTML('beforeend', newItems.innerHTML); currentPageEl.value = nextPage; }
    } catch(e){ console.error(e); }
    finally {
      if (nextPage < totalPages) { loadMoreBtn.disabled = false; loadMoreBtn.querySelector('[load-more-text]')?.classList.remove('hide'); loadMoreBtn.querySelector('[loader]')?.classList.add('hide'); }
      else loadMoreBtn.style.display = 'none';
    }
  });
});



